import React from 'react';
import { Link } from 'react-router-dom';
import { Book } from '@/types';
import { formatDuration } from '@/utils/format';

interface BookCardProps {
  book: Book;
}

const BookCard: React.FC<BookCardProps> = ({ book }) => {
  return (
    <Link to={`/book/${book.id}`}>
      <div className="group h-full bg-[var(--bg-card)] rounded-xl overflow-hidden border border-[var(--border)] hover:border-[var(--accent-primary)] transition-all duration-300 shadow-sm hover:shadow-md hover:scale-[1.02]">
        {/* Cover image or placeholder */}
        <div className="relative w-full aspect-[2/3] bg-gradient-to-br from-[var(--accent-primary)]/20 to-[var(--accent-secondary)]/20 flex items-center justify-center overflow-hidden">
          {book.cover_image_url ? (
            <img
              src={book.cover_image_url}
              alt={book.title}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform"
            />
          ) : (
            <div className="text-center px-4">
              <span className="text-4xl">📚</span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-4">
          {/* Title */}
          <h3 className="text-lg font-serif font-semibold text-[var(--text-primary)] mb-2 line-clamp-2 group-hover:text-[var(--accent-primary)] transition-colors">
            {book.title}
          </h3>

          {/* Author */}
          <p className="text-sm text-[var(--text-secondary)] mb-3">
            by {book.author}
          </p>

          {/* Description */}
          <p className="text-sm text-[var(--text-secondary)] mb-4 line-clamp-2">
            {book.description}
          </p>

          {/* Stats */}
          <div className="flex gap-2 flex-wrap mb-4">
            <span className="inline-block px-2 py-1 rounded-md bg-[var(--bg-secondary)] text-xs font-medium text-[var(--text-primary)]">
              {formatDuration(book.total_duration_seconds)}
            </span>
            <span className="inline-block px-2 py-1 rounded-md bg-[var(--bg-secondary)] text-xs font-medium text-[var(--text-primary)]">
              {book.chapter_count} {book.chapter_count === 1 ? 'chapter' : 'chapters'}
            </span>
          </div>

          {/* CTA */}
          <button className="w-full py-2 px-3 rounded-lg bg-[var(--accent-primary)] text-white text-sm font-medium hover:bg-[var(--accent-hover)] transition-colors">
            Listen Now
          </button>
        </div>
      </div>
    </Link>
  );
};

export default BookCard;
